import { render, staticRenderFns } from "./FolderFileConfirmDeleteAnswerDialog.vue?vue&type=template&id=6228fa1e&scoped=true"
import script from "./FolderFileConfirmDeleteAnswerDialog.vue?vue&type=script&lang=js"
export * from "./FolderFileConfirmDeleteAnswerDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderFileConfirmDeleteAnswerDialog.vue?vue&type=style&index=0&id=6228fa1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228fa1e",
  null
  
)

export default component.exports